import { Component, ElementRef, input, ViewChild, inject, signal } from '@angular/core';
import { ButtonComponent } from '../../../components/button/button.component';
import { AuthService } from '../../../state/auth/auth.service';
import { LinkComponent } from '../../../components/link/link.component';
import { User } from '@shared/interfaces/user';
import { HeaderMenuComponent } from '../header-menu/header-menu.component';
import { ModalService } from '../../../state/modal/modal.service';
import { EulaViewComponent } from '../eula-view/eula-view.component';

@Component({
  selector: 'app-header',
  imports: [ButtonComponent, LinkComponent, HeaderMenuComponent],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css',
})
export class HeaderComponent {
  authService = inject(AuthService);
  modalService = inject(ModalService);
  public isOnLandingPage = input<boolean>(false);
  protected user = signal<User | undefined>(undefined);
  protected menuOpen = signal(false);
  @ViewChild('header', { static: true }) eRef!: ElementRef;
  private handleClickOutsideBound: (event: MouseEvent) => void;

  constructor() {
    this.authService.user.then((user) => {
      this.user.set(user || undefined);
    });
    this.handleClickOutsideBound = this.handleClickOutside.bind(this);
  }

  public doAutoLogin() {
    this.doLogin();
  }

  public doSignUp() {
    this.modalService.openModal(EulaViewComponent);
  }

  public doLogin() {
    this.authService.signIn();
  }

  public toggleMenu() {
    this.menuOpen.update((isOpen) => !isOpen);
    if (this.menuOpen()) {
      this.addClickListener();
    } else {
      this.removeClickListener();
    }
  }

  addClickListener() {
    document.addEventListener('click', this.handleClickOutsideBound);
  }

  removeClickListener() {
    document.removeEventListener('click', this.handleClickOutsideBound);
  }

  handleClickOutside(event: MouseEvent) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.menuOpen.set(false);
      this.removeClickListener();
    }
  }
}
